import { render, staticRenderFns } from "./AreaManagers.vue?vue&type=template&id=388113b8"
import script from "./AreaManagers.vue?vue&type=script&lang=js"
export * from "./AreaManagers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports